import { useEffect, useRef } from 'react';

import omit from 'lodash/omit';
import { useRouter } from 'next/router';
import { useChains } from 'wagmi';

import { SWITCH_NETWORK_INVALID } from '@/constants/analytics';
import { trackEvent } from '@/dapp-sdk-v2';
import { useChainData } from '@/hooks/useChainData';

const useSetNetworkFromQP = () => {
  const router = useRouter();
  const chains = useChains();
  const { chainId, switchChain } = useChainData();

  const timeout = useRef<NodeJS.Timeout>();

  useEffect(() => {
    if (!router.query.chain) {
      return () => void 0;
    }

    const chain = parseInt(router.query.chain as string);

    if (chainId === chain) {
      router.push({
        query: omit(router.query, ['chain']),
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chainId, router.query.chain]);

  const switchNetwork = (network: number) => {
    const isValidChain = chains.some((chain) => chain.id === network);
    if (isValidChain) {
      switchChain(network, {
        source: 'query-param',
      });
    } else {
      trackEvent(SWITCH_NETWORK_INVALID, {
        new_chain_id: network,
        reason: 'invalid chain id from query param',
        source_of_switch: 'query-param',
        available_chains: chains.map((chain) => chain.id),
      });
    }
  };

  useEffect(() => {
    if (router.query.chain != null) {
      const chain = parseInt(router.query.chain as string);

      if (timeout.current) {
        clearTimeout(timeout.current);
      }

      timeout.current = setTimeout(() => switchNetwork(chain), 1_000);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.chain]);
};

export { useSetNetworkFromQP };
